import { createReducer } from '@reduxjs/toolkit';
import { apiRequestFailed, apiRequestSuccess } from 'services/api/api.actions';

import { unprocessableEntity_422 } from 'services/api/api.statusCodes';
import { postVerifyEmailEndpoint } from 'services/verifyEmail/verifyEmail.config';

const initialState = {
  isVerifyEmail: false,
  textVerifyEmail: '',
};

const verifyEmailReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(apiRequestSuccess, (state, action) => {
      const { payload } = action;

      if (payload.resourceId === postVerifyEmailEndpoint) {
        state.isVerifyEmail = true;
        state.textVerifyEmail = 'text.successVerifyEmail';
        return;
      }
    })
    .addCase(
      apiRequestFailed,
      (state, { payload: { resourceId, error, requestConfig } }) => {
        if (resourceId === postVerifyEmailEndpoint) {
          if (error?.response?.status === unprocessableEntity_422) {
            state.isVerifyEmail = false;

            const errorInfos = error.response.data?.error?.errorInfos;

            if (!errorInfos) {
              return;
            }

            if (errorInfos.generic) {
              state.textVerifyEmail = errorInfos.generic[0];
            }
          }

          return;
        }
      },
    ),
);

export default verifyEmailReducer;
